import firebase from 'firebase'

firebase.initializeApp({
  apiKey: 'AIzaSyAujRaAgTwhjgVVWjW7-o4JIFdo6151h3A',
  authDomain: 'queued-217c4.firebaseapp.com',
  databaseURL: 'https://queued-217c4.firebaseio.com',
  projectId: 'queued-217c4',
  storageBucket: 'queued-217c4.appspot.com',
  messagingSenderId: '387751457038',
  appId: '1:387751457038:web:ecc6a5e466d1fbecf1275f',
  measurementId: 'G-WM2MN00JJC'
})
firebase.performance()

export default firebase
